export enum DialogPopupCssVars {
  /**
   * Indicates how many dialogs are nested within.
   * @type {number}
   */
  nestedDialogs = '--nested-dialogs',
}
